import { Subject, Subscription } from 'rxjs';
import { AuthService } from './../../core/auth/auth.service';
import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/core/auth/user.model';
import { RelationContactService } from 'src/app/core/services/relation-contact.service';

@Component({
  selector: 'app-relations-contacts',
  templateUrl: './relations-contacts.component.html',
  styleUrls: ['./relations-contacts.component.sass']
})
export class RelationsContactsComponent implements AfterContentInit, OnDestroy {

  relationContactsListing:any = [];
  showLoadMoreButton:boolean = false;
  relationsLoading:boolean = false;
  currentPage:number = 1;
  current_user:User;
  searchResults: Subject<any> = new Subject<any>();

  showStoredQueries:boolean = false;
  storedQueryData:any;

  $subscription1:Subscription;
  $subscription2:Subscription;

  constructor(private relationContactService: RelationContactService, private authService: AuthService) {
    this.authService.user.subscribe(res => {
      this.current_user = res;
    })
  }

  ngAfterContentInit(): void {
    //this.loadRelationContacts();
  }

  onStoredQueryClicked(storedQueryData:any){
    if(this.$subscription1){
      this.$subscription1.unsubscribe();
    }
    this.storedQueryData = storedQueryData;
    this.currentPage = 1;
    this.relationContactsListing = [];
    this.loadRelationContacts();
  }

  loadRelationContacts(){
    this.relationsLoading = true;

    this.$subscription1 = this.relationContactService.getRelationContactList(this.currentPage, this.storedQueryData).subscribe(resData => {
      if(resData){

        if(resData.items.length < 20){
          this.showLoadMoreButton = false;
        }else{
          this.showLoadMoreButton = true;
        }
        if(this.relationContactsListing.find(o => o.page === this.currentPage)){
          this.relationContactsListing.find((o:{page:number, items:[]}, i:number) => {
            if (o.page === this.currentPage) {
                this.relationContactsListing[i] = resData;
                return true;
            }else{
              return false;
            }
          });
        }else{
          this.relationContactsListing.push(resData);
        }

        this.relationsLoading = false;

        this.addPhotoUrlToContacts();
      }
    });
  }


  onNextPage(){
    if(this.relationsLoading == false){
      this.currentPage++;
      this.loadRelationContacts();
    }
  }

  addPhotoUrlToContacts(){
    var sess = this.current_user.sessionId;
    this.relationContactsListing.forEach(function(page){
      page.items.forEach(function(relation){

        // Create a fullname field
        relation.fullname = '';
        if(relation.Person.firstName)
          relation.fullname += relation.Person.firstName;
        if(relation.Person.infix)
          relation.fullname += ' ' + relation.Person.infix;
        if(relation.Person.lastName)
          relation.fullname += ' ' + relation.Person.lastName;

        if(relation.Person.photoFileName){
          relation.photoUrl = environment.fileServiceDownload + '?ouid=' + relation.uid + '&class=RelationContactPhoto&sessionId=' + sess;
        }else{
          relation.photoUrl = null;
        }
      });
    });
  }


  onSearchInput(searchInput:string){

    if(this.$subscription2){
      this.$subscription2.unsubscribe();
    }

    var sess = this.current_user.sessionId;
    // There should be at least 2 characters
    if (searchInput.length > 2) {
      this.$subscription2 = this.relationContactService
        .getSearchResults(searchInput)
        .subscribe((resData) => {
          if (resData) {
            resData.items.forEach(function(relationContact){
              // Create a fullname field
              relationContact.fullname = '';
              if(relationContact.Person.firstName)
                relationContact.fullname += relationContact.Person.firstName;
              if(relationContact.Person.infix)
                relationContact.fullname += ' ' + relationContact.Person.infix;
              if(relationContact.Person.lastName)
                relationContact.fullname += ' ' + relationContact.Person.lastName;

              if(relationContact.Person.photoFileName){
                relationContact.photoUrl = environment.fileServiceDownload + '?ouid=' + relationContact.uid + '&class=RelationContactPhoto&sessionId=' + sess;
              }else{
                relationContact.photoUrl = null;
              }
            });

            this.searchResults.next(resData);
          } else {
            this.searchResults.next([]);
          }
        });
    } else {
      this.searchResults.next([]);
    }
  }

  ngOnDestroy(): void {
    if(this.$subscription1){
      this.$subscription1.unsubscribe();
    }
  }

}

